<div class='dialog'>
  <span class="text-result">You have successfully uploaded {{data.countSuccessful}} row(s).</span>
  <p class="text-result">{{data.countUnsuccessful}} row(s) have failed to upload.</p>
  <p class="title">Detail</p>

  <mat-dialog-content class='dialog-content'>
    <div class="table-detail">
      <table>
        <tr>
          <th>Row</th>
          <th>Reason for failure</th>
        </tr>
        <tbody *ngIf="data.details.length > 0">
          <tr *ngFor="let row of data.details">
            <td class="text-center">{{row.rowIndex}}</td>
            <td class="text-left">
              <span class="d-flex" *ngFor="let reason of row.reasons">{{reason}}</span>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="data.details.length === 0">
          <tr>
            <td class="no-data" colspan="2">No result found</td>
          </tr>
        </tbody>
      </table>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button class='btn btn-lg btn-greengo' mat-button mat-dialog-close>OK</button>
  </mat-dialog-actions>
</div>